import api from '@/utils/api';

/**
 * Get  supplier's products by a selected product category
 * @param {string} supplierId - the supplier id
 * @param {string} productCategoryId - the product category id
 * @returns {Promise}
 */
const getSupplierProductsByProductCategoryApi = (
  supplierId,
  productCategoryId,
) => {
  const url = `/dealer/${supplierId}/product/category/${productCategoryId}`;
  return api.get(url);
};

/**
 * Get  supplier's products by a selected product category
 * @param {string} supplierId - the supplier id
 * @returns {Promise}
 */
export const getSupplierProductsByProductCategoryApiLazy =
  (supplierId) => (productCategoryId) => {
    const url = `/dealer/${supplierId}/product/category/${productCategoryId}`;
    return api.get(url);
  };

export default getSupplierProductsByProductCategoryApi;
